import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { TripProvider, UIProvider, useTrip, useUI } from "@/lib/store";
import { AccessGate } from "@/components/AccessGate";
import { BottomNav, TopBar, StatusStrip } from "@/components/Nav";
import { DriverCard } from "@/components/DriverCard";
import { EventEditor } from "@/components/EventEditor";
import { AssistantButton, AssistantSheet } from "@/components/Assistant";
import { WhatsNextSheet } from "@/components/WhatsNext";
import { SearchSheet } from "@/components/SearchSheet";
import { QuickAddSheet } from "@/components/QuickAdd";
import { IdeaEditor } from "@/components/IdeaEditor";
import { ExpenseEditor } from "@/components/ExpenseEditor";
import Home from "@/pages/Home";
import Trip from "@/pages/Trip";
import Calendar from "@/pages/Calendar";
import MapView from "@/pages/MapView";
import Ideas from "@/pages/Ideas";
import More from "@/pages/More";

function Shell() {
  const { trip, loading, error, access } = useTrip();
  const { driver, closeDriver } = useUI();
  if (!access) return <AccessGate />;
  if (!trip) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[var(--jade-deep)] px-6 text-center text-[var(--parchment)]">
        <div>
          <p className="eyebrow !text-[var(--brass)]">{error ? "Offline" : "Preparing"}</p>
          <h1 className="font-display mt-2 text-4xl font-semibold">Mary's Birthday China Adventure</h1>
          <p className="mt-3 text-sm text-[var(--parchment)]/70">{error || (loading ? "Loading the itinerary…" : "")}</p>
        </div>
      </div>
    );
  }
  return (
    <AccessGate>
      <TopBar />
      <StatusStrip />
      <main className="mx-auto min-h-screen max-w-md px-4 pb-28 md:max-w-5xl md:px-6 md:pb-16">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/trip" element={<Trip />} />
          <Route path="/calendar" element={<Calendar />} />
          <Route path="/map" element={<MapView />} />
          <Route path="/ideas" element={<Ideas />} />
          <Route path="/more/*" element={<More />} />
        </Routes>
      </main>
      <AssistantButton />
      <BottomNav />
      <DriverCard hotel={driver} onClose={closeDriver} />
      <EventEditor />
      <AssistantSheet />
      <WhatsNextSheet />
      <SearchSheet />
      <QuickAddSheet />
      <IdeaEditor />
      <ExpenseEditor />
    </AccessGate>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <TripProvider>
        <UIProvider>
          <Shell />
          <Toaster position="top-center" richColors closeButton />
        </UIProvider>
      </TripProvider>
    </BrowserRouter>
  );
}
